// Celebratory burst of musical-note particles, used by the welcome-back banner.
// Pure DOM + Web Animations API; no dependencies. Skipped for reduced motion.

const NOTE_GLYPHS = ['♪', '♫', '♩', '♬'];
const NOTE_COLORS = ['#fbbf24', '#f59e0b', '#ffffff', '#a78bfa', '#818cf8'];

export function burstMusicNotes(originEl, count = 26) {
  if (!originEl || typeof document === 'undefined') return () => {};
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return () => {};
  }

  const rect = originEl.getBoundingClientRect();
  const cx = rect.left + rect.width / 2;
  const cy = rect.top + rect.height / 2;

  const container = document.createElement('div');
  container.style.cssText =
    'position:fixed;inset:0;pointer-events:none;z-index:2000;overflow:hidden;';
  document.body.appendChild(container);

  for (let i = 0; i < count; i++) {
    const el = document.createElement('span');
    el.textContent = NOTE_GLYPHS[i % NOTE_GLYPHS.length];
    const size = 14 + Math.random() * 14;
    el.style.cssText =
      `position:absolute;left:${cx}px;top:${cy}px;font-size:${size}px;` +
      `color:${NOTE_COLORS[i % NOTE_COLORS.length]};` +
      'text-shadow:0 1px 3px rgba(0,0,0,0.4);will-change:transform,opacity;';
    container.appendChild(el);

    // Launch upward/outward, then fall under gravity while spinning
    const vx = (Math.random() - 0.5) * 420; // px/s horizontal spread
    const vy = -(140 + Math.random() * 280); // px/s initial upward
    const gravity = 460; // px/s^2
    const spin = (vx >= 0 ? 1 : -1) * (180 + Math.random() * 300); // deg/s
    const duration = 1800 + Math.random() * 900; // ms

    const steps = 6;
    const frames = [];
    for (let s = 0; s <= steps; s++) {
      const t = (duration / 1000) * (s / steps);
      frames.push({
        transform:
          `translate(${vx * t}px, ${vy * t + 0.5 * gravity * t * t}px) ` +
          `rotate(${spin * t}deg)`,
        opacity: s === steps ? 0 : 1, // fade out over the last segment
      });
    }
    el.animate(frames, { duration, easing: 'linear', fill: 'forwards' });
  }

  const timer = setTimeout(() => container.remove(), 3000);
  return () => {
    clearTimeout(timer);
    container.remove();
  };
}
